import { useSelector } from "react-redux";
import { createSelector } from "reselect";

import { RootState } from "store";

const getState = (state: RootState) => state;

export const getSearchChannel = createSelector(getState, state => state.search);

export const getSearchVisibleSelector = createSelector(
  getSearchChannel,
  ({ searchVisible }) => {
    return searchVisible;
  },
);

export function useIsSearchVisibile(): boolean {
  return useSelector(getSearchVisibleSelector);
}

export const getSearchTerm = createSelector(
  getSearchChannel,
  ({ searchTerm }) => {
    return searchTerm;
  },
);
export function useSearchTerm(): string {
  return useSelector(getSearchTerm) || "";
}

export const getSearchType = createSelector(
  getSearchChannel,
  ({ activeSearchType }) => {
    return activeSearchType;
  },
);

export const getSearchSelected = createSelector(
  getSearchChannel,
  ({ searchSelected }) => {
    return searchSelected;
  },
);

export const getSearchTypes = createSelector(
  getSearchChannel,
  ({ searchTypes }) => {
    return searchTypes;
  },
);

export const getSearchIndex = createSelector(
  getSearchChannel,
  ({ indexName }) => {
    return indexName;
  },
);

export const getSearchSetting = createSelector(
  getSearchChannel,
  ({ indexName, searchTypes }) => {
    return {
      indexName,
      searchTypes,
    };
  },
);
